import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { GridFilterGroup } from "@hermes/states/grid-filters-state";

@Component({
    selector: "h-grid-filter-group",
    templateUrl: "./grid-filter-group.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridFilterGroupComponent {
    @Input()
    public gridFilterGroup: GridFilterGroup;
    @Input()
    public isOpen: boolean;
    constructor() {}

    /**
     * @returns Function that return if the present filter is
     * on the good type
     * @param type Type of filter for the component
     */
    public isTypeFilter(...type: string[]): boolean {
        return type.includes(this.gridFilterGroup.presentation);
    }
}
